import { render, staticRenderFns } from "./salesTable.vue?vue&type=template&id=dbf766bc&scoped=true"
import script from "./salesTable.vue?vue&type=script&lang=js"
export * from "./salesTable.vue?vue&type=script&lang=js"
import style0 from "./salesTable.vue?vue&type=style&index=0&id=dbf766bc&prod&scoped=true&lang=css"
import style1 from "./salesTable.vue?vue&type=style&index=1&id=dbf766bc&prod&lang=css"
import style2 from "./salesTable.vue?vue&type=style&index=2&id=dbf766bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf766bc",
  null
  
)

export default component.exports